import React from "react";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import { useSelector } from 'react-redux';
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import Teams from "components/AboutUs/Teams";
import { useEffect } from "react";

function AboutUs () {
    const isMobile = useSelector(state=> state.windowSize.isMobile);
    
    useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);
    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <Teams />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <Teams />
            <Footer />
            </>
        )}
        </>
    )
};

export default AboutUs